import {createSelector} from "reselect";
import {selectCurrentParticipant} from "../../../module/participant/participant.slice";
import {TEnoField} from "../../models/entities/information/enoField";
import {EParticipant} from "../../models/entities/participant/participant";
import {TParticipants} from "../../models/types/Participants";
import {selectCurrentOperation} from "../../../module/operation/operation.slice";

const participants = (state: {participants: TParticipants}) => state.participants;

const selectUserParticipants = createSelector(participants, (participants) => participants && participants.participants);

const selectOperationParticipants = createSelector(selectUserParticipants, selectCurrentOperation, (participants, operation) => {
	return participants.filter((participant) => participant._operationId === operation.id);
});

const selectParticipantInfos = createSelector(
	selectCurrentParticipant,
	selectCurrentOperation,
	(currentParticipant, operation) => {
		const participantInfos: TEnoField[][] = [];
		participantInfos.push([
			{
				_type: `${operation.dso}.dsoPrmNumber`,
				_value: currentParticipant._dsoDetails._prm
					? currentParticipant._dsoDetails._prm
					: currentParticipant._dsoDetails._ean || "",
				_editable: false,
			},
		]);
		participantInfos.push([
			{
				_type: "address",
				_value: currentParticipant._dsoDetails._address || "",
				_editable: true,
			},
		]);
		participantInfos.push([{_type: "city", _value: currentParticipant._dsoDetails._city || "", _editable: true}]);
		participantInfos.push([
			{
				_type: "postCode",
				_value: currentParticipant._dsoDetails._postCode || "",
				_editable: true,
			},
		]);
		participantInfos.push([{_type: "firstName", _value: currentParticipant._dsoDetails._name || "", _editable: true}]);
		return participantInfos || [];
	}
);
const selectBillingInfos = createSelector(selectCurrentParticipant, (currentParticipant) => {
	const participantInfos: TEnoField[][] = [];
	participantInfos.push([
		{
			_type: "firstName",
			_value: currentParticipant._billableEntity?._name || currentParticipant._billingDetail._name || "",
			_editable: true,
		},
	]);
	participantInfos.push([
		{
			_type: "address",
			_value: currentParticipant._billableEntity?._address || currentParticipant._billingDetail._address || "",
			_editable: true,
		},
	]);
	participantInfos.push([
		{
			_type: "city",
			_value: currentParticipant._billableEntity?._city || currentParticipant._billingDetail._city || "",
			_editable: true,
		},
	]);
	participantInfos.push([
		{
			_type: "postCode",
			_value: currentParticipant._billableEntity?._postCode || currentParticipant._billingDetail._postCode || "",
			_editable: true,
		},
	]);

	participantInfos.push([
		{
			_type: "phoneNumber",
			_value: currentParticipant._billableEntity?._phoneNumber || currentParticipant._billingDetail._phoneNumber || "",
			_editable: true,
		},
	]);
	participantInfos.push([
		{
			_type: "email",
			_value: currentParticipant._billableEntity?._email || currentParticipant._billingDetail._email || "",
			_editable: true,
		},
	]);
	return participantInfos || [];
});
const selectParticipantsDsoDetails = createSelector(selectOperationParticipants, (participants) =>
	participants.map((participant: EParticipant) => participant._dsoDetails)
);

export {
	selectBillingInfos,
	selectParticipantInfos,
	selectParticipantsDsoDetails,
	selectUserParticipants,
	selectOperationParticipants,
};
